export interface NotificationCountResponse {
  count: number;
}

export interface NotificationMetadata {
  id: string;
  [key: string]: string;
}

export interface NotificationListItem {
  id: string;
  type: string;
  title: string;
  entity: string;
  entityId: string;
  isRead: boolean;
  hasCta: boolean;
  ctaLabel?: string;
  metadata: NotificationMetadata;
  createdAt: string;
}

export enum NOTIFICATION_ENTITY {
  COLLECTION = "collection",
  CAMPAIGN = "campaign",
  DEAL = "deal",
  SUBSCRIPTION = "subscription",
  USER_FEATURE_QUOTA = "user_feature_quota",
}

export enum NOTIFICATION_TYPE {
  CAMPAIGN_COMPLETED = "campaign.completed",
  CAMPAIGN_STARTED = "campaign.started",
  CAMPAIGN_CREATED = "campaign.created",
  SUBSCRIPTION_PAYMENT_FAILED = "subscription.payment_failed",
  QUOTA_UNUSED = "quota.unused",
  QUOTA_RENEWED = "quota.renewed",
}
